module.exports = __webpack_public_path__ + "static/media/mmf_pausenanimation_small_000.59e601a7.png";